@if (isChatbotAllowed) { 
<sabis-chatbot-floating-button (chatbotVisibilityChanged)="onVisibleChatbotChange($event)"
                               [config]="chatbotConfig" [floatingButtonBottom]="90" [floatingButtonRight]="20"
                               (contentClick)="onChatbotContentClick($event)"
                               [isSessionIdVisible]="this.isSessionIdVisible" />
}
